import React, { useState, useEffect } from 'react';
import './App.css';

import {BrowserView, MobileView, isMobileOnly, isAndroid, isIOS} from 'react-device-detect'

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './Components/Desktop/Header/Header';
import Home from './Components/Desktop/Home/Home';
import ContactUs from './Components/Desktop/ContactUs/ContactUs';
import DownloadApp from './Components/Desktop/DownloadApp/DownloadApp';
import Features from './Components/Desktop/Features/Features';
import Industries from './Components/Desktop/Industries/Industries';
import Create from './Components/Desktop/Create/Create';
import Preview from './Components/Desktop/Preview/Preview';
import Login from './Components/Desktop/Login/Login';
import ProjectView from './Components/Desktop/ProjectView/ProjectView';
import Pricing from './Components/Desktop/Pricing/Pricing';

import MHeader from './Components/Mobile/MHeader/MHeader';
import MFeatures from './Components/Mobile/MFeatures/MFeatures'
import MIndustries from './Components/Mobile/MIndustries/MIndustries';
import MContactUs from './Components/Mobile/MContactUs/MContactUs';
import MHome from './Components/Mobile/MHome/MHome';
import MDownloadApp from './Components/Mobile/MDownloadApp/MDownloadApp';
import MFooter from './Components/Mobile/MFooter/MFooter';
import MCreate from './Components/Mobile/MCreate/MCreate';
import MPricing from './Components/Mobile/MPricing/MPricing';
import MLogin from './Components/Mobile/MLogin/MLogin';



import Footer from './Components/Common/Footer/Footer';
import ForgotPassword from './Components/Desktop/ForgotPassword/ForgotPassword';

import * as Network from './Components/Network/Network';

const App = () => {

  const [create, setCreate] = useState(false);
  const [file, setFile] = useState("");
  const [ssObjs, setSSObjs] = useState({});
  const [fpWidth, setFpWidth] = useState(0);
  const [fpHeight, setFpHeight] = useState(0);
  const [preview, setPreview] = useState(false);
  const [fpX, setFpx] = useState(0);
  const [fpY, setFpy] = useState(0);
  const [fpBase64, setFpBase64] = useState("");
  const [fpType, setFpType] = useState("");
  const [snapSize, setSnapSize] = useState(0.05);
  const [fpOgWidth,setFpOgWidth] = useState(0);
  const [fpOgHeight, setFpOgHeight] = useState(0);
  const [sharePressed, setSharePressed] = useState(false);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [regMode, setRegMode] = useState(true);
  const [subPlan, setSubPlan] = useState(0);
  const [fpObj, setFpObj] = useState({});
  const [address, setAddress] = useState("No Address");
  const [email, setEmail] = useState((user&&user.email)?user.email:"");
  const [coordMap,setCoordMap] = useState({});
  const [galMap, setGalMap] = useState({});
  const [selectedCoord, setSelectedCoord] = useState({});
  const [sortedByX, setSortedByX] = useState([]);
  const [mapOfX, setMapOfX] = useState({});

  useEffect(() =>  {
    console.log(`updating local storage`);
    console.log(user);
    localStorage.setItem("user", JSON.stringify(user));
  }, [user]);

  return (
    <>
      {!isMobileOnly
      ?
      <div className="App">
        <div className="Inner">
          <BrowserRouter>
          { !preview &&
          <Header file={file} create={create} setCreate={setCreate} user={user} setUser={setUser} setRegMode={setRegMode} setEmail={setEmail}></Header>
          }
          <div className="MapIt-body">
            <Routes>
              <Route exact path="/" element={<Home create={create} setCreate={setCreate}/>}></Route>
              <Route exact path="/features" element={<Features/>}></Route>
              <Route exact path="/industries" element={<Industries/>}></Route>
              <Route exact path="/download" element={<DownloadApp/>}></Route>
              <Route exact path="/contact" element={<ContactUs/>}></Route>
              <Route exact path="/create" element={
                <Create
                fpBase64={fpBase64}
                setFpBase64={setFpBase64}
                file={file}
                setFile={setFile} 
                ssObjs={ssObjs} 
                setSSObjs={setSSObjs} 
                fpWidth={fpWidth} 
                setFpWidth={setFpWidth}
                fpHeight={fpHeight} 
                setFpHeight={setFpHeight}
                setPreview={setPreview}
                fpX={fpX}
                fpY={fpY}
                setFpx={setFpx}
                setFpy={setFpy}
                fpType={fpType}
                setFpType={setFpType}
                snapSize={snapSize}
                setSnapSize={setSnapSize}
                fpOgHeight={fpOgHeight}
                fpOgWidth={fpOgWidth}
                setFpOgHeight={setFpOgHeight}
                setFpOgWidth={setFpOgWidth}
                sharePressed={sharePressed}
                setSharePressed={setSharePressed}
                user={user}
                setUser={setUser}
                setSubPlan={setSubPlan}
                setRegMode={setRegMode}
                setFpObj={setFpObj}
                address={address}
                setAddress={setAddress}
                email={email}
                setEmail={setEmail}
                coordMap={coordMap}
                setCoordMap={setCoordMap}
                galMap={galMap}
                setGalMap={setGalMap}
                selectedCoord={selectedCoord}
                setSelectedCoord={setSelectedCoord}
                mapOfX={mapOfX}
                setMapOfX={setMapOfX}
                sortedByX={sortedByX}
                setSortedByX={setSortedByX}/>}>
              </Route>
              <Route exact path='/preview' element={
                <Preview
                fpType={fpType}
                fpBase64={fpBase64}
                floorplan={file} 
                fpHeight={fpHeight} 
                fpWidth={fpWidth} 
                ssObjs={ssObjs}
                setPreview={setPreview}
                snapSize={snapSize}
                setSharePressed={setSharePressed}
                coordMap={coordMap}
                galMap={galMap}
                selectedCoord={selectedCoord}
                setSelectedCoord={setSelectedCoord}
                mapOfX={mapOfX}
                setMapOfX={setMapOfX}
                sortedByX={sortedByX}
                setSortedByX={setSortedByX}/>}>
              </Route>
              <Route exact path='/login' element={
                <Login setUser={setUser} 
                regMode={regMode} 
                setRegMode={setRegMode} 
                subPlan={subPlan} 
                setSubPlan={setSubPlan}
                fpObj={fpObj}
                address={address}
                email={email}
                setEmail={setEmail}></Login>
              }>
              </Route>
              <Route exact path='/projectview' element={
                <ProjectView user={user} setUser={setUser}></ProjectView>
              }>
              </Route>
              <Route exact path='/forgot-password' element={
                <ForgotPassword></ForgotPassword>
              }>
              </Route>
              <Route exact path='/pricing' element={
                <Pricing subPlan={subPlan} setSubPlan={setSubPlan} setRegMode={setRegMode} user={user} setUser={setUser}></Pricing>
              }>
              </Route>
            </Routes>
          </div>
          </BrowserRouter>
          { !preview &&
          <Footer create={create}></Footer>
          }
        </div>
      </div>
      : // mobile browser website
      <div className="App">
        <div className="mInner">
          <BrowserRouter>
          <MHeader create={create} setCreate={setCreate} user={user} setUser={setUser} setRegMode={setRegMode} setEmail={setEmail}></MHeader>
          <div className="mMapIt-body">
            <Routes>
              <Route exact path="/" element={<MHome/>}></Route>
              <Route exact path="/features" element={<MFeatures/>}></Route>
              <Route exact path="/industries" element={<MIndustries/>}></Route>
              <Route exact path="/download" element={<MDownloadApp/>}></Route>
              <Route exact path="/contact" element={<MContactUs/>}></Route>
              <Route exact path="/create" element={<MCreate
                fpBase64={fpBase64}
                setFpBase64={setFpBase64}
                file={file}
                setFile={setFile} 
                ssObjs={ssObjs} 
                setSSObjs={setSSObjs} 
                fpWidth={fpWidth} 
                setFpWidth={setFpWidth}
                fpHeight={fpHeight} 
                setFpHeight={setFpHeight}
                setPreview={setPreview}
                fpX={fpX}
                fpY={fpY}
                setFpx={setFpx}
                setFpy={setFpy}
                fpType={fpType}
                setFpType={setFpType}
                snapSize={snapSize}
                setSnapSize={setSnapSize}
                fpOgHeight={fpOgHeight}
                fpOgWidth={fpOgWidth}
                setFpOgHeight={setFpOgHeight}
                setFpOgWidth={setFpOgWidth}
                sharePressed={sharePressed}
                setSharePressed={setSharePressed}
                subPlan={subPlan}/>}>
              </Route>
              <Route exact path='/pricing' element={
                <MPricing subPlan={subPlan} setSubPlan={setSubPlan} setRegMode={setRegMode} user={user} setUser={setUser}></MPricing>
              }>
              </Route>
              <Route exact path='/login' element={
                <MLogin setUser={setUser} 
                regMode={regMode} 
                setRegMode={setRegMode} 
                subPlan={subPlan} 
                setSubPlan={setSubPlan}
                fpObj={fpObj}
                address={address}
                email={email}
                setEmail={setEmail}></MLogin>
              }>
              </Route>
              <Route exact path='/projectview' element={
                <ProjectView user={user} setUser={setUser}></ProjectView>
              }>
              </Route>
            </Routes>
          </div>
          </BrowserRouter>
          <MFooter></MFooter>
        </div>
      </div>
      }
    </>
  );
}

export default App;
